import { render, staticRenderFns } from "./index-tpl.vue?vue&type=template&id=2a2b6c3c&scoped=true"
import script from "./index-tpl.vue?vue&type=script&lang=js"
export * from "./index-tpl.vue?vue&type=script&lang=js"
import style0 from "./index-tpl.vue?vue&type=style&index=0&id=2a2b6c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2b6c3c",
  null
  
)

export default component.exports